import axios from 'axios'
import { toast } from 'react-toastify'
import { useCallback, useMemo, useRef, useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import { useSelector } from 'react-redux'

import InvitedTable from './components/InvitedTable'
import MembersSearchInput from './components/MembersSearchInput'
import TablePlaceholder from './components/TablePlaceholder'

import classes from './InvitedPage.module.scss'

import { deserialize } from '../../utility/serialization'
import { debounce } from '../../utility/debounceHelper'
import { requestGetInvitations } from '../../actions/communitiesActions'


const InvitedPage = () => {
  const { loadedInvitedData } = useOutletContext()
  const abortController = useRef(null)
  const communityId = useSelector(state => state.user.current_user.communities[0].id)
  const [students, setStudents] = useState(loadedInvitedData?.invitations)
  const [searchText, setSearchText] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const fetchInvited = useCallback(
    ({ search }) =>
      requestGetInvitations({
        communityId,
        search,
        signal: abortController.current?.signal,
      })
        .then(response => {
          const data = deserialize(response.data)
          setStudents(data.invitations)
        }),
    [communityId]
  )

  const updateInvited = useCallback(
    (params) => {
      setIsLoading(true)
      fetchInvited({ search: searchText, ...params })
        .catch((res) => {
          if (!axios.isCancel(res)) {
            toast.error('Something went wrong. Please try again.', { position: toast.POSITION.TOP_RIGHT })
          }
        })
        .finally(() => { setIsLoading(false) })
    },
    [fetchInvited, searchText]
  )

  const debouncedSearch = useMemo(
    () => debounce((search) => updateInvited({ search })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const handleSearch = (e) => {
    setSearchText(e.target.value)
    debouncedSearch(e.target.value)
  }

  return (
    <main className={classes.wrapper}>
      <header className='py-3 d-flex align-items-center'>
        <div className={classes.searchWrapper}>
          <MembersSearchInput placeholder='Search for Students' value={searchText} onChange={handleSearch} />
        </div>
      </header>
      {students?.length === 0 ? (
        <TablePlaceholder message='No Invitations' />
      ) : (
        <InvitedTable students={students} isLoading={isLoading} />
      )}
    </main>
  )
}

export default InvitedPage
